import styled from "styled-components";

export const HiveHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 8px;
    
    @media screen and (max-width: 1000px) {
        padding-bottom: 0;
    }
`

export const HiveHeaderTabsWrapper = styled.div`
    width: 220px;
    
    .tabs-item {

        height: 48px;
        width: max-content;
        
        .tabs-item__text {
            font-size: 14px;
            font-weight: 500;
            width: max-content;
        }
    }
`

export const ButtonsRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`